import { render, staticRenderFns } from "./AddPriceProductModal.vue?vue&type=template&id=712cc6b8&scoped=true&"
import script from "./AddPriceProductModal.vue?vue&type=script&lang=js&"
export * from "./AddPriceProductModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPriceProductModal.vue?vue&type=style&index=0&id=712cc6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712cc6b8",
  null
  
)

component.options.__file = "AddPriceProductModal.vue"
export default component.exports